<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Список сервисных ботов</strong>
                </CCardHeader>

                <CCardBody>
                    <table v-if="list.length" class="table">
                        <thead>
                            <th>Бот</th>
                            <th>Приветственное сообщение</th>
                            <th>Активен</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in list" :key="item.id">
                                <td>
                                    {{ item.bot_name }}
                                </td>
                                <td>
                                    <CButton
                                        v-if="item.bot_name === 'TELEGRAM_FEEDBACK_BOT'"
                                        class="mr-3 mb-3"
                                        color="dark"
                                        @click="updateSettingsModal()"
                                    >Настройки</CButton>
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="item.enabled"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        @update:checked="updateData(item.id)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else>Список пуст</div>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="light"
                        @click="goBack"
                    >Назад</CButton
                    >
                </CCardFooter>
        
                <CModal
                    title="Приветственное сообщение"
                    :show.sync="newMessage"
                    :footer="false"
                    color="info"
                >
                    <template>
                        <div slot="body-wrapper" class="modal-body">
                            <CForm>
                                <CRow>
                                    <CCol sm="12" class="form-group">Введите приветственное сообщение для пользователя:</CCol>
                                </CRow>
                                <CRow>
                                    <CCol
                                        sm="12"
                                        class="form-group"
                                    ><CTextarea v-model="comment" /></CCol>
                                </CRow>
                            </CForm>
                        </div>
                        <div slot="footer">
                            <CButton
                                color="light"
                                class="ml-3"
                                @click="newMessage = false"
                            >Отмена</CButton
                            >
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="updateSettings"
                            >Сохранить</CButton
                            >
                        </div>
                    </template>
                </CModal>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    export default {
        name: 'ServiceBots',

        data: () => ({
            list: [],
            newMessage: false,
            comment: '',
            id: null,
        }),

        computed: {},

        mounted() {
            this.fetch();
        },

        methods: {
            async fetch() {
                try {
                    const { data } = await this.axios.get('/telegram/service-bots');
                    this.list = data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async updateData(id) {
                try {
                    const bot = this.list.find(bot => bot.id === id);
                    await this.axios.post('/telegram/service-bots', bot);
                    await this.fetch();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            goBack() {
                this.$router.push({ path: '/telegram' });
            },

            async updateSettings() {
                let id = null;
                for (const bot of this.list) {
                    if(bot.bot_name === "TELEGRAM_FEEDBACK_BOT") {
                        id = bot.id;
                    }
                }
                try {
                    const bot = this.list.find(bot => bot.id === id);
                    bot.welcome_message = this.comment;
                    await this.axios.post('/telegram/service-bots/settings', bot);
                    await this.fetch();

                    this.newMessage = false;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            updateSettingsModal() {
                for (const bot of this.list) {
                    if (bot.welcome_message) {
                        this.comment = bot.welcome_message;
                    }
                }
                this.newMessage = true;
            },
        },
    };
</script>
